import React, { useState } from "react";
import styled from "styled-components";
import PolicyNumberConfig from "components/widgets/forms/setup/policy_number_config";
import BasicDetails from "components/setup/BasicDetails";
import { useQuery } from "react-query";
import { fetch_product_details } from "services/apiSrv";
import { useParams } from "react-router-dom";
import Loader from "components/widgets/loader";
import TableComponent from "components/widgets/table";



// Styled Components
const Container = styled.div`
  padding: 24px;
  max-width: 100%;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 16px;
  color: #333;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  max-height: 60vh;
  overflow-y: auto;
  margin-bottom: 32px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 8px rgb(0 0 0 / 0.1);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
  }

  th {
    background: #f4f4f4;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  @media (max-width: 768px) {
    th,
    td {
      padding: 8px;
      font-size: 12px;
    }
  }

  @media (max-width: 480px) {
    th,
    td {
      padding: 6px;
      font-size: 10px;
    }
  }
`;

const Section = styled.div`
  margin-bottom: 48px;
`;

export default function MotorCertificateConfigPage() {
    const { id: productSystemRef} = useParams()

    const { data, isLoading, isError, error, refetch } = useQuery({
      queryKey: ['productDetails', productSystemRef],
      queryFn: () => fetch_product_details(productSystemRef),
      enabled: !!productSystemRef,
      retry: 2,
      staleTime: 5 * 60 * 1000,
    });
  
    if (isLoading) {
      return <Loader/>;
    }
  
    if (isError) {
      return <p>Error fetching product details: {error?.message || 'Something went wrong'}</p>;
    }
  
    if (!data?.data) {
      return <p>No product data available.</p>;
    }
  
    const { policyNumberConfig } = data.data[0];
    console.log("POLICYNUMBER==", policyNumberConfig)

    let config = {}
    if(!!policyNumberConfig){
      if(policyNumberConfig?.policyNumConfigcategory === "RANGE"){
        config.type = "Range"
        config.value = policyNumberConfig?.policyNumConfigRangeTable.join(",")
        config.minNotificationRange = policyNumberConfig?.policyNumrangeMinimumNotification

      } else if (policyNumberConfig?.policyNumConfigcategory === "FIXED"){
        config.type = "Fixed"
        config.value = String(policyNumberConfig?.policyNumConfigFixed)
        config.minNotificationRange = policyNumberConfig?.policyNumrangeMinimumNotification

      } else if(policyNumberConfig?.policyNumConfigcategory === "AUTO"){
        config.type = "Auto Genenrated"
        config.value = ""
        config.minNotificationRange = policyNumberConfig?.policyNumrangeMinimumNotification
      }

    }


  const configTableFields = [
    { name: "Type" },
    { name: "Value" },
    { name: "Min Notification Range" },
  ];

  const configRowData = [
    { type: "text", field: "type" },
    { type: "text", field: "value" },
    { type: "number", field: "minNotificationRange" },
 
  ];

  return (
    <Container>
      {/* Table Section */}
      <BasicDetails />

      {/* Policy Number Configuration Form Section */}
      <Section>
        <Title>Policy Number Configuration</Title>
        <PolicyNumberConfig data={data.data} refetchProductDetails={refetch} />
       
        {config && (
          <TableComponent 
          row_data={configRowData}
          table_fields={configTableFields}
          table_data={[config]} 
          />
        )}


      </Section>
    </Container>
  );
}
